import React from 'react';
import '../../../styles/GenericSiteStyles.scss';
import './GenericVerticalTabs.scss';
import RoleGuard from '../RoleGuard';

export interface TabConfig {
  key: string;
  label: string;
  allowedRoles?: string;
  content: React.ReactNode;
}


interface GenericVerticalTabsProps {
  tabs: TabConfig[];
  initialTabKey?: string;
  className?: string;
  onTabChange?: (prevTabKey: string, nextTabKey: string) => void;
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
}


const GenericVerticalTabs: React.FC<GenericVerticalTabsProps> = ({ tabs, initialTabKey, className, onTabChange, activeTab: controlledActiveTab, setActiveTab: controlledSetActiveTab }) => {
  const isControlled = controlledActiveTab !== undefined && controlledSetActiveTab !== undefined;
  const [internalActiveTab, setInternalActiveTab] = React.useState(initialTabKey || tabs[0]?.key);
  const activeTab = isControlled ? controlledActiveTab : internalActiveTab;
  const setActiveTab = isControlled ? controlledSetActiveTab : setInternalActiveTab;
  const activeTabObj = tabs.find(tab => tab.key === activeTab) || tabs[0];

  return (
    <div className={`generic-vertical-tabs-root ${className || ''}`}>
      <nav className="generic-vertical-tabs-nav" style={{ minWidth: 160, borderRight: '1px solid #e3e6f3', padding: '20px 0', display: 'flex', flexDirection: 'column', gap: 8 }}>
        {tabs.map(tab => (
          <RoleGuard roles={tab.allowedRoles}>
            <button
              key={tab.key}
              type="button"
              className={`tab-btn${activeTab === tab.key ? ' active' : ''}`}
              style={{
                background: activeTab === tab.key ? '#f0f0ff' : 'none',
                border: 'none',
                borderRight: activeTab === tab.key ? '3px solid #6610f2' : '3px solid transparent',
                color: activeTab === tab.key ? '#6610f2' : '#222',
                fontWeight: 600,
                fontSize: 16,
                padding: '12px 20px',
                textAlign: 'left',
                cursor: 'pointer',
                outline: 'none',
                transition: 'background 0.2s, border 0.2s, color 0.2s',
                borderRadius: 0,
              }}
              onClick={() => {
                if (tab.key !== activeTab) {
                  if (onTabChange) onTabChange(activeTab, tab.key);
                  setActiveTab(tab.key);
                }
              }}
            >
              {tab.label}
            </button>
          </RoleGuard>
        ))}
      </nav>
      <div className="generic-vertical-tabs-content" style={{ flex: 1, padding: 20 }}>
        <RoleGuard roles={activeTabObj?.allowedRoles}>
          {activeTabObj?.content}
        </RoleGuard>
      </div>
    </div>
  );
};

export default GenericVerticalTabs;
